import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
    useSlots,
    useAttrs,
    ref,
    watch,
    nextTick,
} from 'vue';
import {
    Modal as AModal,
} from 'ant-design-vue';

type OnConfirm = () => Promise<boolean | void> | boolean | void;

/**
 * Открывает confirm-модалку.
 * @param onConfirm — опциональный обработчик Ok.
 *   Вернуть `false` (или rejected Promise) — оставить окно открытым.
 *   Иначе окно закрывается, Promise от show() резолвится в `true`.
 *   Cancel → `false`.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalController',
  props: {
    okDisabled: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as { okDisabled?: boolean }



const slots = useSlots();
const attrs = useAttrs();
const visible = ref(false);

const show = (onConfirm?: OnConfirm) => new Promise<boolean>((resolve) => {
    visible.value = true;
    const defaultSlot = slots.default;
    if (!defaultSlot) {
        throw new Error('Modal controller: default slot is not provided');
    }
    let settled = false;
    const settle = (value: boolean) => {
        if (settled) {
            return;
        }
        settled = true;
        resolve(value);
    };

    const M = AModal.confirm({
        ...attrs,
        content: defaultSlot({ visible: visible.value }),
        async onOk() {
            if (onConfirm) {
                const result = await onConfirm();
                if (result === false) {
                    // ant-design-vue не закрывает модалку при rejected Promise
                    throw new Error('modal-keep-open');
                }
            }
            settle(true);
        },
        cancelText: 'Отменить',
        onCancel() {
            visible.value = false;
            settle(false);
            AModal.destroyAll();
        },
    });
    watch(
        () => props.okDisabled,
        () => {
            nextTick(() => {
                M.update({ okButtonProps: { disabled: props.okDisabled } });
            });
        },
        { immediate: true },
    );
});

expose({
    show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i"))
}
}

})